import React, { useEffect, useMemo, useState } from "react";
import "accountOwner/pages/Scheduler/components/SchedulerFilters/SchedulerFilters.scss";
import { useOfficeList } from "repositories/office-policy-management-repository";
import { useAllActiveOffices } from "repositories/scheduler-repository";
import { useQueryClient } from "react-query";
import useOfficeContextOfficeList, {
  getAssignedToYouAllActiveParams,
} from "hooks/useOfficeContextOfficeList";
import constants from "../../../../../../constants";

function OfficeFilter({
  setOfficeFilter,
  selectedOffice,
  t,
  isStaff = false,
  accountOwnerId = null,
}) {
  const queryClient = useQueryClient();
  const { isOfficeNavigationContext, officeList: contextOfficeList } =
    useOfficeContextOfficeList(undefined, { enabled: !isStaff });
  const { data: officeListData, refetch } = useOfficeList(
    accountOwnerId,
    isStaff,
    { enabled: !isStaff && !isOfficeNavigationContext },
  );
  const { data: assignedToYouOfficeData } = useAllActiveOffices(
    1,
    constants.ACTIVE_OFFICES_PAGE_SIZE,
    getAssignedToYouAllActiveParams(accountOwnerId),
    "",
    { enabled: isStaff },
  );
  const [selectAll, setSelectAll] = useState(false);

  const data = useMemo(() => {
    if (isStaff) {
      if (!assignedToYouOfficeData?.data?.length) return [];
      return assignedToYouOfficeData.data
        .map((office) => ({
          id: office.id ?? office.officeId,
          name: office.name ?? office.officeName ?? "",
        }))
        .filter((office) => office.id != null);
    }
    if (isOfficeNavigationContext) {
      return contextOfficeList;
    }
    return officeListData;
  }, [
    isOfficeNavigationContext,
    contextOfficeList,
    isStaff,
    assignedToYouOfficeData,
    officeListData,
  ]);

  useEffect(() => {
    if (isOfficeNavigationContext || isStaff) return;
    queryClient.invalidateQueries([
      "/officePolicies/officeList",
      accountOwnerId,
    ]);
    refetch();
  }, [
    accountOwnerId,
    refetch,
    queryClient,
    isOfficeNavigationContext,
    isStaff,
  ]);

  useEffect(() => {
    setSelectAll(selectedOffice?.length === data?.length);
  }, [selectedOffice, data]);

  const handleChange = (e, item) => {
    const offices = [...selectedOffice];
    const officeIndex = offices.findIndex((v) => +item.id === +v);
    if (e.target.checked) {
      offices.push(item.id);
    } else if (officeIndex > -1) {
      offices.splice(officeIndex, 1);
    }
    setOfficeFilter(offices);
    setSelectAll(false);
  };

  const handleAllChange = (e) => {
    setSelectAll(e.target.checked);
    setOfficeFilter(
      e.target.checked && data?.length ? data.map((item) => item.id) : [],
    );
  };

  return (
    <ul className={["filter-list"]}>
      {data?.length > 0 && (
        <>
          <li>
            <div className="ch-checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={handleAllChange}
                  checked={selectAll}
                />
                <span>{t("notes.allFilters")}</span>
              </label>
            </div>
          </li>
          <hr className="mr-4" />
        </>
      )}
      {data?.map((item, key) => (
        <li key={key}>
          <div className="ch-checkbox">
            <label>
              <input
                type="checkbox"
                onChange={(e) => handleChange(e, item)}
                checked={selectedOffice.includes(item.id)}
              />
              <span> {item.name}</span>
            </label>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default OfficeFilter;
